import { Model } from './model';
import { Client } from './client';

export class User extends Model {
  name: string;
  email: string;
  client: Client;
  superAdmin: boolean;

  constructor(data?: any) {
    super(data);

    if (data) {
      this.name = data.name;
      this.email = data.email;
      this.client = new Client(data.client);
      this.superAdmin = data.superadmin ? true : false;
    }
  }

  toJson(): any {
    return undefined;
  }
}



// WEBPACK FOOTER //
// ./src/app/models/user.ts